export const keys = {
  // ===================================
  // Event Base Keys w/ interaction_type
  // ===================================

  betLoop: 'bet_loop',
  bonuses: 'bonuses',
  faveNumbersEvent: 'favourite_numbers',
  favourites: 'favourites',
  mfa: 'mfa',
  shareBet: 'share_bet',
  tipsPreviews: 'tips_previews',
  searchInteraction: 'search_interaction',
  search: 'search',

  // =================
  // Legacy Event Keys
  // =================

  loginForgotPassword: 'login-forgot-password',
  loginForgotAccountNumber: 'login-forgot-account-number',
  loginForgotAccountNumberSent: 'login-forgot-account-number-sent',
  loginResetPasswordSuccess: 'login-reset-password-success',
  loginSuccess: 'login-success',
  loginFailed: 'login-failed',
  logout: 'logout',

  profileSettingsChange: 'profile-settings-change',

  accountDropDownOpened: 'account-dropdown-opened',
  accountDropDownClick: 'accountDropDownClick',

  accountManagement: 'account_management',

  navExit: 'nav.exit',

  betAccountSelected: 'bet-account',
  betAccountReview: 'bet-account-review',
  betAccountProcessed: 'bet-account-processed',

  quickbetOpen: 'quickbet-open',
  quickbetClosed: 'quickbet-closed',

  quickbetBonusBetButtonShown: 'quickbet-bonus-bet-button-shown',
  quickbetBonusBetButtonActivated: 'quickbet-bonus-bet-button-activated',
  quickbetBonusBetButtonDeactivated: 'quickbet-bonus-bet-button-deactivated',
  quickbetBonusBetSelected: 'quickbet-bonus-bet-selected',
  quickbetBonusBetUnselected: 'quickbet-bonus-bet-unselected',
  quickbetBonusCashSelected: 'quickbet-bonus-cash-selected',
  quickbetBonusCashUnselected: 'quickbet-bonus-cash-unselected',
  quickbetBonusBetProposed: 'quickbet-bonus-bet-proposed',
  quickbetBonusBetAddedToBetslip: 'quickbet-bonus-bet-added-to-betslip',
  quickbetBonusCashRemoved: 'quickbet-bonus-cash-removed',
  quickbetBonusCashButtonActivated: 'quickbet-bonus-cash-button-activated',
  quickbetBonusCashButtonDeactivated: 'quickbet-bonus-cash-button-deactivated',
  mysteryBonusCashButtonActivated: 'mystery-bonus-cash-button-activated',
  mysteryBonusCashButtonDeactivated: 'mystery-bonus-cash-button-deactivated',

  betslipBetAdded: 'add-to-betslip',
  betslipCleared: 'betslip_clear',

  multiToastClicked: 'multi_toast_clicked',

  blackbookPushAlertChosen: 'blackbook_push_alert_chosen',
  blackbookSmsAlertChosen: 'blackbook_sms_alert_chosen',
  blackbookAlertPromptClosed: 'blackbook_alert_prompt_closed',

  betslipBonusBetButtonDeactivated: 'betslip-bonus-bet-button-deactivated',
  betslipBonusBetChosen: 'betslip-bonus-bet-chosen',
  betslipBonusBetConfirmed: 'betslip-bonus-bet-confirmed',
  betslipBonusCashRemoved: 'betslip-bonus-cash-removed',

  visionOpened: 'vision-opened',
  visionClosed: 'vision-closed',
  visionPositionChanged: 'vision-position-changed',
  visionFullScreenOn: 'vision-full-screen-on',
  visionFullScreenOff: 'vision-full-screen-off',
  visionSky1Selected: 'vision-sky-1-selected',
  visionSky2Selected: 'vision-sky-2-selected',
  visionRacingWASelected: 'vision_racing_wa_selected',
  visionRaceReplaySelected: 'vision_race_replay_selected',
  visionWindowResized: 'vision-window-resized',
  visionMuted: 'vision-mute-on',
  visionUnMuted: 'vision-mute-off',

  skyPendingBetsOpen: 'sky_pending_bets_open',
  skyPendingBetsClosed: 'sky_pending_bets_closed',

  radioOn: 'radio-on',
  radioOff: 'radio-off',

  trendingBetSelected: 'trending-bet-selected',
  trendingBetSortingChanged: 'trending-bet-sorting-changed',

  raceNotificationEnabled: 'race-notification-enabled',
  raceNotificationDisabled: 'race-notification-disabled',

  shareBetLinkOpen: 'share-bet-link-open',
  shareBetLinkLogin: 'share-bet-link-login',
  shareBetLinkAcquisition: 'share-bet-link-acquisition',
  shareBetLinkPlaced: 'share-bet-link-placed',

  shareBlackbook: 'share-blackbook',

  rebet: 're-bet',
  loadedBetBetslip: 'loaded-bet-betslip',

  takeABreakInformation: 'take-a-break-information',
  takeABreakConfirmation: 'take-a-break-confirmation',
  takeABreakAlreadyActive: 'take-a-break-already-active',
  takeABreakCancel: 'take-a-break-cancel',
  takeABreakSubmitSelection: 'take-a-break-submit-selection',
  takeABreakSubmitSucceeded: 'take-a-break-submit-succeeded',
  takeABreakSubmitFailed: 'take-a-break-submit-failed',

  activityStatementsSelected: 'activity-statements-selected',

  accountActivityTabChange: 'account-activity-tab-change',

  productSelectionChanged: 'product-selection-changed',

  racePromotionLoaded: 'race-promotion-loaded',
  racePromotionOpened: 'race-promotion-opened',
  racePromotionClosed: 'race-promotion-closed',
  racePromotionTermsAndConditionsClicked: 'race-promotion-terms-and-conditions-clicked',

  racePreviewLoaded: 'race-preview-loaded',
  racePreviewOpened: 'race-preview-opened',
  racePreviewClosed: 'race-preview-closed',

  raceReplayOpened: 'race-replay-opened',
  raceReplayLaunched: 'race_replay_launched',
  raceReplayFullScreen: 'race_replay_fullscreen',
  raceReplayMute: 'race_replay_mute',
  raceReplayClosed: 'race_replay_closed',

  giddyUpOpen: 'giddyup-open',
  giddyUpClosed: 'giddyup-closed',
  giddyUpShowSpeedMap: 'giddyup-showspeedmap',
  giddyUpShowAllRating: 'giddyup-showallrating',
  giddyUpShowTopRating: 'giddyup-showtoprating',
  giddyUpShowQuaddieTips: 'giddyup-showquaddietips',

  betInformerButtonPressed: 'bet-informer-button-pressed',
  betModifierButtonPressed: 'bet-modifier-button-pressed',

  meetingsCalendarNextMonth: 'meetings-calendar-next-month',
  meetingsCalendarPrevMonth: 'meetings-calendar-prev-month',
  meetingsCalendarSelectMonth: 'meetings-calendar-select-month',
  meetingsCalendarOpened: 'meetings-calendar-opened',
  meetingsCalendarSelectedDay: 'meetings-calendar-selected-day',
  meetingsRaceCodeToggle: 'meetings-race-code-toggle',
  meetingsDayQuickSelect: 'meetings-day-quick-select',
  meetingsDayPrevArrow: 'meetings-day-prev-arrow',
  meetingsDayNextArrow: 'meetings-day-next-arrow',

  tipsBetClicked: 'tips-bet-clicked',
  racePreviewBetClicked: 'race-preview-bet-clicked',

  biometricsTogglePressed: 'biometrics-toggle-pressed',

  hamburgerMenuClicked: 'hamburger-menu-clicked',

  blackbookOddsClicked: 'blackbook-odds-clicked',
  blackbookAlertsUpdated: 'blackbook-alerts-updated',
  blackbookNavigateToRace: 'blackbook-navigate-to-race',
  blackbookEntryDeleteClicked: 'blackbook-entry-delete-clicked',
  blackbookEntryDeleted: 'blackbook-entry-deleted',
  blackbookEntryDeleteCanceled: 'blackbook-entry-delete-canceled',
  blackbookEntryExpanded: 'blackbook-entry-expanded',
  blackbookSortChanged: 'blackbook-sort-changed',
  blackbookCommentClicked: 'blackbook-comment-clicked',
  blackbookCommentCancel: 'blackbook-comment-cancel',
  blackbookCommentSave: 'blackbook-comment-save',
  blackbookAddRunner: 'blackbook-add-runner',
  blackbookGoToBlackbook: 'blackbook-go-to-blackbook',
  blackbookUnableToAdd: 'blackbook-unable-to-add',
  blackbookChangeView: 'blackbook-change-view',

  featureBannerViewed: 'view_promotion',
  featureItemBannerViewed: 'view_promotion',
  featureBannerClicked: 'select_promotion',
  featureItemClicked: 'select_promotion',

  categoryNavigation: 'category-navigation',
  navigationClick: 'navigation_click',

  quickDepositShown: 'quick-deposit-shown',
  quickDepositStarted: 'quick-deposit-started',
  quickDepositSucceeded: 'quick-deposit-succeeded',
  quickDepositFailed: 'quick-deposit-failed',
  quickDepositCancelled: 'quick-deposit-cancelled',
  quickDepositOtherDepositClicked: 'quick-deposit-other-deposit-clicked',
  quickDepositEditBetClicked: 'quick-deposit-edit-bet-clicked',
  quickDeposit3dSecure: 'quick-deposit-3d-secure',
  quickDepositNon3dSecure: 'quick-deposit-non-3d-secure',
  quickDeposit3dSecureNotShifted: 'quick-deposit-3d-secure-not-shifted',
  quickDeposit3dSecureError: 'quick-deposit-3d-secure-error',
  quickDeposit3dSecureUserDataSuccess: 'quick-deposit-3d-secure-user-data-success',
  quickDeposit3dSecureUserDataFail: 'quick-deposit-3d-secure-user-data-fail',

  raceCardSwiped: 'race-card-swiped',

  raceCardPendingBetsOpen: 'race_card_pending_bets_open',
  raceCardPendingBetsViewAll: 'race_card_pending_bets_view_all',
  raceCardResultedBetsOpen: 'race_card_resulted_bets_open',
  raceCardResultedBetsViewAll: 'race_card_resulted_bets_view_all',

  raceCardSorting: 'race_card_sorting',

  skyRaceCardListViewOpen: 'sky_race_card_list_view_open',
  skyRaceCardFilterCodeUpdate: 'sky_race_card_filter_code_update',
  skyRaceCardFilterRegionUpdate: 'sky_race_card_filter_region_update',
  moreSkyRacesLoaded: 'sky_race_card_show_more',
  resetSkyScrollView: 'sky_race_card_return_first_race',

  setPageVisit: 'set_page_visit',
  moneyDeposited: 'money_deposited',
  withdrawal: 'withdrawal',
  visitedRacePage: 'visited_race_page',
  visitedAndHasBonusOffer: 'visited_and_has_bonus_offer',
  redeemedBonusOffer: 'redeemed_bonus_offer',
  venueModeEntry: 'venue_mode_entry',
  venueModeExit: 'venue_mode_exit',
  venueModePresent: 'venue_mode_present',

  appHeaderBetSlipButtonClick: 'header_betslip',
  appHeaderPendingBetsClick: 'header_pending_bets',
  betSlipPendingBetsClick: 'betslip_pending_bets',

  formOpened: 'form_opened',
  formClosed: 'form_closed',

  shortenedUrlAccessed: 'shortened_url_accessed',

  infinityScroll: 'infinity_scroll_tracking',
} as const
